<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/destiny"
      title="Lista rodzajów przeznaczenia produktu"
      :numeral_text="[
        'rodzaj przeznaczenia',
        'rodzaje przeznaczenia',
        'rodzajów przeznaczenia',
      ]"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
